var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImbitNextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 122.64 35.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000a3d;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.41,
    y1: 170.48,
    x2: 87.41,
    y2: 161.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#622965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6c58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 95.6,
    y1: 170.48,
    x2: 95.6,
    y2: 161.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 103.58,
    y1: 170.48,
    x2: 103.58,
    y2: 161.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 111.38,
    y1: 170.48,
    x2: 111.38,
    y2: 161.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 58.11,
    y1: 32.37,
    x2: 58.11,
    y2: 31.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 112.15,
    y1: 32.37,
    x2: 112.15,
    y2: 31.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 58.11,
    y1: 33.97,
    x2: 58.11,
    y2: 33.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 112.15,
    y1: 33.97,
    x2: 112.15,
    y2: 33.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 29.93,
    y1: 151.73,
    x2: 50.03,
    y2: 151.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 29.93,
    y1: 157.03,
    x2: 59.22,
    y2: 157.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 33.82,
    y1: 145.42,
    x2: 44.85,
    y2: 145.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 32.94,
    y1: 150.23,
    x2: 44.01,
    y2: 150.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 32.01,
    y1: 155.05,
    x2: 43.17,
    y2: 155.05,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "full hd_svg_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.4,138.94h4.17v18H61.4Z",
    transform: "translate(-13.68 -132.32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.27,157l0-10.82-5.31,8.92H79.05l-5.28-8.69V157H69.85v-18h3.46l6.75,11.21,6.65-11.21h3.43l0,18Z",
    transform: "translate(-13.68 -132.32)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111,152.06c0,3.12-2.47,4.92-7.21,4.92H94.47v-18h8.81c4.51,0,6.83,1.88,6.83,4.69a4.33,4.33,0,0,1-2.4,4A4.46,4.46,0,0,1,111,152.06Zm-12.4-10v4.25h4.15c2,0,3.15-.72,3.15-2.14s-1.11-2.11-3.15-2.11Zm8.2,9.53c0-1.52-1.16-2.24-3.32-2.24H98.61v4.46h4.88C105.65,153.84,106.81,153.17,106.81,151.62Z",
    transform: "translate(-13.68 -132.32)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.18,138.94h4.18v18h-4.18Z",
    transform: "translate(-13.68 -132.32)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.37,142.34H120.6v-3.4h15.72v3.4h-5.77V157h-4.18Z",
    transform: "translate(-13.68 -132.32)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.11,161.46h.8v5.91h-.82l-3.37-4.57v4.57h-.81v-5.91h.82L89.11,166Z",
    transform: "translate(-13.68 -132.32)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.27,164.43a1.35,1.35,0,0,1,.52,1.11,1.68,1.68,0,0,1-.28,1,1.94,1.94,0,0,1-.8.66,2.87,2.87,0,0,1-1.21.24,4,4,0,0,1-1.12-.17,3.28,3.28,0,0,1-1-.45l.34-.66a2.64,2.64,0,0,0,.79.43,2.55,2.55,0,0,0,.9.16,1.86,1.86,0,0,0,1.14-.32,1,1,0,0,0,.41-.83.92.92,0,0,0-.41-.8,2.16,2.16,0,0,0-1.17-.27h-.81V164l1.82-1.78H93.7v-.74h3.8V162l-2,2,.35,0A2.47,2.47,0,0,1,97.27,164.43Z",
    transform: "translate(-13.68 -132.32)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.06,161.46h1l1.55,2.2,1.56-2.2h.95l-2,2.84,2.17,3.07h-1L103.56,165l-1.7,2.39h-1l2.16-3Z",
    transform: "translate(-13.68 -132.32)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.07,161.46h4.61v.75h-1.9v5.16H111v-5.16h-1.9Z",
    transform: "translate(-13.68 -132.32)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 47.67,
    y: 31.81,
    width: 20.88,
    height: 0.57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.71,
    y: 31.81,
    width: 20.88,
    height: 0.57
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 47.67,
    y: 33.4,
    width: 20.88,
    height: 0.57
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 101.71,
    y: 33.4,
    width: 20.88,
    height: 0.57
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M50,138.71l-1.33,7.61-.2,1.2-2.23,12.83A22,22,0,0,0,30,164.88l0,0h0a17.8,17.8,0,0,1,14.18-7.15L46,147l.12-.66.86-5c-3.67-1.31-10.92.27-13.29,1.9A21.93,21.93,0,0,1,50,138.71Z",
    transform: "translate(-13.68 -132.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M59.22,149.64l-12.55,18A21.82,21.82,0,0,0,32,164.53c-.69.1-1.37.22-2,.38h0l.05,0a16.7,16.7,0,0,1,4.26-1.64,18.47,18.47,0,0,1,11.57,1.17l9.49-13.63a14.62,14.62,0,0,0-5.95-3l.24-1.36A21.78,21.78,0,0,1,59.22,149.64Z",
    transform: "translate(-13.68 -132.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.93,164.92s-6.42-17.64-16.25-22.62A16.53,16.53,0,0,1,29,147.11s2.56-11.34,11.91-14.63c0,0-9.64,7.51-9.73,19.82,0,0-4.83-5.86-9.88-7C21.28,145.27,28.6,150.47,29.93,164.92Z",
    transform: "translate(-13.68 -132.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.11,
    cy: 3.37,
    r: 3.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M44.85,143.2l-.39,2.25c-3.29-.65-8.8.81-10.64,2.18A18.7,18.7,0,0,1,44.85,143.2Z",
    transform: "translate(-13.68 -132.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M44,148l-.39,2.27c-3.29-.67-8.82.8-10.68,2.17A18.79,18.79,0,0,1,44,148Z",
    transform: "translate(-13.68 -132.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M43.17,152.83l-.39,2.29c-3.28-.72-8.9.76-10.77,2.15A18.74,18.74,0,0,1,43.17,152.83Z",
    transform: "translate(-13.68 -132.32)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImbitNextLogo);
export default __webpack_public_path__ + "static/media/imbitNextLogo.67b8e745ad5cb18e624c9078a70d3b85.svg";
export { ForwardRef as ReactComponent };